var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.75 240.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.75,0v36.14c-3.01,1.08-6.09,1.93-9.25,2.37-7.21,1-15.05-.38-20.5-5.41-7.18-6.62-9.28-18.48-17.7-23.24-4.15-2.34-9.08-2.46-13.8-2.37-4.71.1-9.58.34-13.99-1.42C63.68,4.94,61.08,2.74,59.68,0h82.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave1.d060b3dd65ee1fb84fab7dbcb58a72dc.svg";
export { ForwardRef as ReactComponent };